import { validateMOQ } from '../../api/MOQ/MOQApi';
import { IMOQValidationResponse } from '../../api/MOQ/IMOQValidationResponse';
import { AxiosResponse } from 'axios';

export const CLEAR_MOQ_VALIDATION = 'CLEAR_MOQ_VALIDATION';
export type CLEAR_MOQ_VALIDATION = typeof CLEAR_MOQ_VALIDATION;

export const validateMOQRequest = (): any => {
  return (dispatch: any) => {
    dispatch({
      type: 'VALIDATE_MOQ_REQUEST',
    });

    return validateMOQ()
      .then((response: AxiosResponse<any>) => {
        if (response.status === 200) {
          dispatch({
            type: 'VALIDATE_MOQ_RESPONSE',
            response: response.data.ValidateMOQ || response.data,
          });
        } else {
          onError(dispatch);
        }
      })
      .catch((err: any) => {
        onError(dispatch);
      });
  };
};

const onError = (dispatch: any) => dispatch({
  type: 'VALIDATE_MOQ_ERROR',
});

export const clearMOQValidation = () => {
  return {
    type: CLEAR_MOQ_VALIDATION,
  };
};
